import { Component, OnInit, signal, DestroyRef, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { tap } from 'rxjs';
import { GoogleAuthProvider} from '@angular/fire/auth';
import { Router } from '@angular/router';
import { LayoutService } from '../../../service/layout.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-firebase-sign-in',
  templateUrl: './firebase-sign-in.component.html',
  styleUrls: ['./firebase-sign-in.component.scss']
})
export class FirebaseSignInComponent implements OnInit {

  form = new FormGroup({
    email: new FormControl<string>("", {
      nonNullable: true,
      validators: [Validators.required, Validators.email]
    }),
    password: new FormControl<string>("", {
      nonNullable: true,
      validators:[Validators.required]
    })
  });
  show = false;
  userNotFound = false;
  wrongPassword = false;
  passwordTouched = false;
  emailTouched = false;
  isMakena = environment.makena;
  APP_NAME = environment.envName;
  loaderSgn = signal(true);
  private _destroyRef = inject(DestroyRef);
  private _auth = inject(AngularFireAuth);
  private _router = inject(Router);
  protected layout = inject(LayoutService);

  ngOnInit() {
    this._auth.authState
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap(() => this.loaderSgn.set(true))
      )
      .subscribe(user => {
        if (user) {
          this._auth.setPersistence('local');
          this._router.navigate(['company']);
        } else {
          this.loaderSgn.set(false);
        }
      })
  }

  async onSubmit() {
    const { email, password } = this.form.getRawValue();
    this._auth.signInWithEmailAndPassword(email, password)
      .catch(err => this.errorHandler(err));
  }

  validate() {
    if (this.form.controls.email.valid) {
      this.userNotFound = false;
    }
    if (this.form.controls.email.touched && !this.form.controls.email.valid) {
      this.userNotFound = true;
    }
    if (this.form.controls.password.valid) {
      this.wrongPassword = false;
    }
    if (this.form.controls.password.touched && !this.form.controls.password.valid) {
      this.wrongPassword = true;
    }
  }

  async signInWithGoogle() {
    const provider = new GoogleAuthProvider()
    provider.setCustomParameters({
      prompt: 'select_account'
    });
    this._auth.signInWithPopup(provider);
  }

  errorHandler(err: any) {
    this.showLoginFailReason(err.message)
  }

  showLoginFailReason(errorMessage: string) {
    const errorReason = errorMessage.match(/auth\/?[a-zA-Z-]+/)?.[0]
    switch (errorReason?.replace("auth/", "").trim()) {
      case "wrong-password":
        this.wrongPassword = true;
        this.form.controls.password.setErrors({ wrong: true })
        break;
      case "user-not-found":
        this.userNotFound = true;
        this.form.controls.email.setErrors({ notFound: true })
        break;
      default:
        return;
    }
  }
}
